<svelte:options
    customElement={{
    tag: "hopper-auction-cinema-v1",
    shadow: "none",
    props: {
      variationId: { type: "String", attribute: "variation-id" },
      eventMergeId: { type: "String", attribute: "event-merge-id" },
    },
  }}
/>

<script lang="ts">
  import BasicCinema from "./lib/basic-cinema/BasicCinema.svelte";
  import CinemaHeader from "./lib/cinema-header/CinemaHeader.svelte";
  import {onMount} from "svelte";
  import {fetchCinemaProducts} from "./lib/CinemaService";
  import type {CinemaProps} from "./index";
  import type {CinemaSponsoredProduct} from "./types/CinemaProductsDto.types";
  import DsaSheet from "./lib/dsa-sheet/DsaSheet.svelte";
  import {logError} from "../logger.ts";
  import {addLabels} from "@otto-ec/global-resources/apm";

  const {
    variationId,
    eventMergeId,
  }: CinemaProps = $props();
  let variations = $state<CinemaSponsoredProduct[]>([]);
  let auctionId = $state("");
  let cinemaTrackingLabels = $state<Record<string, string[]>>({});
  let dsaSheet: DsaSheet | undefined = $state();
  let allProductTilesFailed = $state(false);

  $effect(() => {
    addLabels({hopper_auction_cinema_version: "new"});

    if (!variationId) {
      logError(Error("Cinema: variationId is required"))
      return;
    }

    fetchCinemaProducts(variationId).then(([err, res]) => {
      if (err) {
        return logError(err);
      }

      variations = res.cinemaSponsoredProducts ?? [];
      auctionId = res.auctionId ?? "";
      cinemaTrackingLabels = res.cinemaTrackingLabels ?? {};
    });
  });

  function openDsaSheet() {
    dsaSheet?.open();
  }
</script>

<div class="spa-cinema">
  {#if variations.length > 0 && !allProductTilesFailed}
    <div class="cinema-container">
      <CinemaHeader {variations} onDsaClick={openDsaSheet}/>
      <BasicCinema
          {variations}
          {auctionId}
          {cinemaTrackingLabels}
          {eventMergeId}
          onAllProductTilesFailed={() => (allProductTilesFailed = true)}
      />
    </div>

    <DsaSheet bind:this={dsaSheet} {variations}/>
  {/if}
</div>

<style lang="scss">
  @use '@otto-ec/design-tokens/tokens';

  .cinema-container {
    display: flex;
    flex-direction: column;
    margin-bottom: tokens.$oc-semantic-spacing-150;
    container-type: inline-size;
  }
</style>
